export default [
  {
    code: 'no',
    id: 1,
    postId: 29,
    rfc5646: 'nb-NO'
  },
  {
    code: 'se',
    id: 2,
    postId: 30,
    rfc5646: 'sv-SE'
  },
  {
    code: 'da',
    platformCode: 'dk',
    id: 3,
    postId: 31,
    rfc5646: 'da-DK'
  },
  {
    code: 'en',
    platformCode: 'gb',
    id: 4,
    postId: 32,
    rfc5646: 'en-GB'
  },
  {
    code: 'fi',
    id: 5,
    postId: 33,
    rfc5646: 'fi-FI'
  }
]
